<div class="container-card" *ngIf="mappedWeather.length > 0">
    <mat-card class="weather-conditions-card">
      <mat-card-title class="weather-conditions-title">
        <i class="fas fa-cloud-sun" style="margin-right: 10px;"></i>
        {{ 'PEST.WEATHER_CONDITIONS' | translate }}
      </mat-card-title>
  
      <div class="row">
        <div class="col" *ngFor="let section of mappedWeather">
          <mat-card-content>
            <div class="weather-column">
              <h3 class="weather-title">
                <i [class]="getIcon(section.period)"></i>
                {{ getTitle(section.period) | translate }}
              </h3>
  
              <div class="weather-table">
                <div class="weather-row weather-header">
                  <span>{{ 'PEST.METRIC' | translate }}</span>
                  <span class="text-center">Min</span>
                  <span class="text-end">Max</span>
                </div>
  
                <div class="weather-row">
                  <div class="text-left">
                    <i class="fas fa-tint"></i> {{ 'PEST.HUMIDITY' | translate }}
                  </div>
                  <span class="text-center">{{ section.data.min_hum_out }}%</span>
                  <span class="text-end">{{ section.data.max_hum_out }}%</span>
                </div>
  
                <div class="weather-row">
                  <div class="text-left">
                    <i class="fas fa-thermometer-half"></i> {{ 'PEST.TEMPERATURE' | translate }}
                  </div>
                  <span class="text-center">{{ section.data.min_temp_out?.toFixed(0) }}°C</span>
                  <span class="text-end">{{ section.data.max_temp_out?.toFixed(0) }}°C</span>
                </div>
  
                <div class="weather-row">
                  <div class="text-left">
                    <i class="fas fa-cloud-rain"></i> {{ 'PEST.RAINFALL' | translate }}
                  </div>
                  <span class="text-center">
                    {{ getRainfallMin(section.period, section.data) }} mm
                  </span>
                  <span class="text-end">
                    {{ getRainfallMax(section.period, section.data) }} mm
                  </span>
                </div>
  
                <div class="weather-row">
                  <div class="text-left">
                    <i class="fas fa-wind"></i> {{ 'PEST.WIND_SPEED' | translate }}
                  </div>
                  <span class="text-center">{{ section.data.min_wind_speed_hi }} km/h</span>
                  <span class="text-end">{{ section.data.max_wind_speed_hi }} km/h</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </div>
    </mat-card>
  </div>
  